import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '赛事直播', path: '/category/football' },
  { name: '数据分析', path: '/category/basketball' },
  { name: '优惠活动', path: '/#promotions' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-2xl md:text-3xl font-heading font-bold tracking-tight text-primary-500">
              bb<span className="text-foreground-950">体育</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-label font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-primary-500 bg-primary-100/70'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about#contact"
              className="px-5 py-2 rounded-lg text-sm font-label font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              登录
            </Link>
            <Link
              to="/about#contact"
              className="px-5 py-2 rounded-lg text-sm font-label font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即注册
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden border-t border-background-200/70 py-4 bg-background-50 animate-in fade-in slide-in-from-top-2 duration-200">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-lg text-sm font-label font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    location.pathname === link.path
                      ? 'text-primary-500 bg-primary-100/70'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="flex items-center gap-3 mt-3 px-4">
                <Link
                  to="/about#contact"
                  className="flex-1 py-2.5 rounded-lg text-sm font-label font-medium text-center text-foreground-700 border border-background-300 hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  登录
                </Link>
                <Link
                  to="/about#contact"
                  className="flex-1 py-2.5 rounded-lg text-sm font-label font-semibold text-center bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  立即注册
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}